import { render, staticRenderFns } from "./InfocardSimulatorIndex.vue?vue&type=template&id=597c1d44&"
import script from "./InfocardSimulatorIndex.vue?vue&type=script&lang=js&"
export * from "./InfocardSimulatorIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports